import { useEffect } from 'react';

/**
 * Hook to handle theme switching for claim.me customer
 * Colors for the themes are in variables.scss
 */
export default function useTheme(isClaimMeCustomer) {
  useEffect(() => {
    if (isClaimMeCustomer) {
      document.title = 'claim.me';
      document.body.setAttribute('data-theme', 'claim.me');
    }

    return () => {
      document.body.removeAttribute('data-theme');
      document.title = 'Seven Senders Portal';
    };
  }, [isClaimMeCustomer]);
}
